import { ReactNode } from 'react';
import styles from './empty-state.module.css';

/**
 * Shared empty-state block (icon + title + hint + optional action), the
 * reference pattern from the compliance/insights pages. `filtered` marks a
 * state produced by active filters so pages can offer a reset action.
 */
export function EmptyState(props: {
  title: string;
  hint?: string;
  variant?: 'structural' | 'filtered';
  children?: ReactNode;
}) {
  const { title, hint, variant = 'structural', children } = props;
  return (
    <div className={styles.empty}>
      <span className={`${styles.icon} ${styles[variant]}`} aria-hidden="true">
        ⌕
      </span>
      <b>{title}</b>
      {hint && <span className={styles.hint}>{hint}</span>}
      {children}
    </div>
  );
}
